const DEFAULT_MIN_VIEWPORT_WIDTH = 1280;

function isDesktopAnchorEligible(options = {}) {
  const config = options.config || {};
  if (config.enabled !== true || options.isTablet === true || options.isSponsored === true) {
    return false;
  }

  const viewportWidth = Number(options.viewportWidth);
  const minViewportWidth = Number.isFinite(Number(config.minViewportWidth))
    ? Number(config.minViewportWidth)
    : DEFAULT_MIN_VIEWPORT_WIDTH;
  return Number.isFinite(viewportWidth) && viewportWidth >= minViewportWidth;
}

function createDesktopAnchorAd(options = {}) {
  const runtimeDocument = options.runtimeDocument
    || (typeof document !== 'undefined' ? document : null);
  if (!runtimeDocument || !runtimeDocument.body || typeof runtimeDocument.createElement !== 'function') {
    return null;
  }

  const slotId = String(options.slotId || 'desktop-anchor-ad');
  const containerId = `${slotId}-container`;
  const existing = typeof runtimeDocument.getElementById === 'function'
    ? runtimeDocument.getElementById(containerId)
    : null;
  if (existing && existing.parentNode && typeof existing.parentNode.removeChild === 'function') {
    existing.parentNode.removeChild(existing);
  }

  const container = runtimeDocument.createElement('aside');
  container.id = containerId;
  container.className = 'milla-desktop-anchor-ad';
  container.setAttribute('aria-label', options.advertisementLabel || 'Advertisement');
  container.style.cssText = [
    'position:fixed',
    'left:50%',
    'bottom:0',
    'transform:translateX(-50%)',
    'z-index:9998',
    'display:none',
    'box-sizing:border-box',
    'max-width:calc(100vw - 32px)',
    'padding:8px',
    'background:#fff',
    'border:1px solid rgba(15,23,42,0.12)',
    'border-bottom:0',
    'border-radius:8px 8px 0 0',
    'box-shadow:0 -4px 18px rgba(15,23,42,0.18)',
    'text-align:center'
  ].join(';');
  container.setAttribute('aria-hidden', 'true');

  const label = runtimeDocument.createElement('div');
  label.className = 'milla-desktop-anchor-ad__label';
  label.textContent = options.advertisementLabel || 'Advertisement';
  label.style.cssText = [
    'margin:0 28px 4px',
    'color:#64748b',
    'font:10px/1.2 Arial,sans-serif',
    'letter-spacing:.04em',
    'text-transform:uppercase'
  ].join(';');

  const adContainer = runtimeDocument.createElement('div');
  adContainer.id = slotId;
  adContainer.className = 'milla-desktop-anchor-ad__slot';
  adContainer.style.cssText = 'display:inline-block;margin:0 auto;min-width:728px;min-height:90px;';

  const closeButton = runtimeDocument.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'milla-desktop-anchor-ad__close';
  closeButton.setAttribute('aria-label', options.closeLabel || 'Close advertisement');
  closeButton.textContent = '\u00d7';
  closeButton.style.cssText = [
    'position:absolute',
    'top:4px',
    'right:4px',
    'width:24px',
    'height:24px',
    'padding:0',
    'border:1px solid #cbd5e1',
    'border-radius:50%',
    'background:#fff',
    'color:#0f172a',
    'font:18px/20px Arial,sans-serif',
    'cursor:pointer'
  ].join(';');

  container.appendChild(label);
  container.appendChild(adContainer);
  container.appendChild(closeButton);
  runtimeDocument.body.appendChild(container);

  let closed = false;
  let destroyed = false;

  function prepare() {
    if (destroyed || closed || !container.style) return;
    container.style.display = 'block';
    container.style.visibility = 'hidden';
    container.style.pointerEvents = 'none';
    container.style.bottom = '-200px';
    container.setAttribute('aria-hidden', 'true');
  }

  function collapse() {
    if (destroyed || !container.style) return;
    container.style.display = 'none';
    container.style.visibility = 'hidden';
    container.style.pointerEvents = 'none';
    container.style.bottom = '0';
    container.setAttribute('aria-hidden', 'true');
  }

  function show() {
    if (destroyed || closed || !container.style) return;
    container.style.display = 'block';
    container.style.visibility = 'visible';
    container.style.pointerEvents = 'auto';
    container.style.bottom = '0';
    container.removeAttribute('aria-hidden');
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    closeButton.onclick = null;
    if (container.parentNode && typeof container.parentNode.removeChild === 'function') {
      container.parentNode.removeChild(container);
    }
  }

  function close() {
    if (closed || destroyed) return;
    closed = true;
    collapse();
    if (typeof options.onClose === 'function') {
      options.onClose();
    }
    destroy();
  }

  closeButton.onclick = close;
  prepare();

  return {
    slotId,
    container,
    adContainer,
    closeButton,
    prepare,
    collapse,
    show,
    close,
    destroy,
    isClosed: () => closed
  };
}

module.exports = {
  createDesktopAnchorAd,
  isDesktopAnchorEligible
};
